import type { IExtractParams } from "@/routes";
import { apiPathFunc } from "@api/util/apiPathFunc";

const pathBase = `/interactive-exams/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const interactiveExams = {
  getAll: apiPathFunc(pathBase),
} as const;
